export function getErrorMessage(error) {
  if (!error) return ''

  if (typeof error === 'string') return error

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message
  }

  if (typeof error?.error === 'string' && error.error.trim()) {
    return error.error
  }

  if (typeof error?.response?.data?.error === 'string') {
    return error.response.data.error
  }

  if (typeof error?.response?.data?.message === 'string') {
    return error.response.data.message
  }

  return ''
}

export function toUserFriendlyErrorMessage(
  error,
  fallback = 'Something went wrong. Please try again.',
) {
  const rawMessage = getErrorMessage(error)
  const normalized = rawMessage.toLowerCase().trim()

  if (!normalized) return fallback

  if (
    normalized.includes('proposal already exists') ||
    normalized.includes('duplicate proposal')
  ) {
    return 'You already sent a proposal for this time. Please choose a different time or wait for a response.'
  }

  if (
    normalized.includes('match already exists') ||
    normalized.includes('match exists')
  ) {
    return 'This match has already been scheduled.'
  }

  // Safety-net: if the server ever leaks raw PostgreSQL error text, translate
  // it here rather than surfacing database internals to the player.
  // The correct long-term fix is server-side error sanitization, but these
  // patterns act as a last-resort client guard in the meantime.
  if (
    normalized.includes('duplicate key value') ||
    normalized.includes('violates unique constraint') ||
    normalized.includes('foreign key constraint') ||
    normalized.includes('violates not-null constraint')
  ) {
    return 'We could not save that update. Please refresh and try again.'
  }

  return fallback
}
